import {LANGUAGES_DROPDOWN_MENU_LIST} from "@/app/[locale]/common/constants/header";

export const getLanguageAbbreviation = (locale: string) => {
    const test = LANGUAGES_DROPDOWN_MENU_LIST.find(lang => lang.locale === locale);

    return test?.title === 'English' ? 'EN' : 'PH';
};